<template>
  <div class="min-vh">
    <div class="d-flex justify-content-between p-3 p-sm-0">
      <h1 class="mb-0 header-main text-uppercase d-inline">
        <span v-if="useSlaFromChannelSetting">{{ id ? "EDIT" : "CREATE" }}</span
        >&nbsp;<span>SLA POLICY</span>
      </h1>
    </div>

    <SlaPolicyForm
      :form="form"
      :platformIdList="platformIdList"
      :isDetail="id ? true : false"
      @save="onClickSave"
      :loading="isLoading"
      :v="$v"
    />
  </div>
</template>

<script>
import SlaPolicyForm from "@/views/pages/setting-sla-policy/components/SlaPolicyForm";
import { requiredIf, required, minValue } from "vuelidate/lib/validators";

export default {
  name: "SettingSLAPolicyPage",
  components: {
    SlaPolicyForm,
  },
  validations() {
    return {
      form: {
        waitDueMinute: {
          required: requiredIf(function (item) {
            return item.waitDueIsEnable === 1;
          }),
        },
        waitDueColor: {
          required: requiredIf(function (item) {
            return item.waitDueIsEnable === 1;
          }),
        },
        waitDueMessage: {
          required: requiredIf(function (item) {
            return item.waitDueIsSendMessage === 1;
          }),
        },
        resolutionDueMinute: {
          required: requiredIf(function (item) {
            return item.resolutionDueIsEnable === 1;
          }),
        },
        resolutionDueColor: {
          required: requiredIf(function (item) {
            return item.resolutionDueIsEnable === 1;
          }),
        },
        resolutionDueMessage: {
          required: requiredIf(function (item) {
            return item.resolutionDueIsSendMessage === 1;
          }),
        },
        resolutionTimeMinute: {
          required: requiredIf(function (item) {
            return item.resolutionTimeEnable === 1;
          }),
        },
        nonBusinessTime: {
          required: requiredIf(function (item) {
            return (
              this.useSlaFromChannelSetting &&
              item.channelBusinessHourEnable === 1
            );
          }),
        },
        nonBusinessColor: {
          required: requiredIf(function (item) {
            return (
              this.useSlaFromChannelSetting &&
              item.channelBusinessHourEnable === 1
            );
          }),
        },
        nonBusinessMessage: {
          required: requiredIf(function (item) {
            return (
              this.useSlaFromChannelSetting && item.nonBusinessSendMessage === 1
            );
          }),
        },
        platformConfigId: {
          required: requiredIf(function () {
            return this.useSlaFromChannelSetting;
          }),
          notSelect99: (value) => value !== 99,
        },
      },
    };
  },
  data() {
    return {
      isLoading: false,
      id: this.$route.params.id,
      form: {
        resolutionDueColor: "",
        resolutionDueIsEnable: 0,
        resolutionDueIsSendMessage: 0,
        resolutionDueMessage: "",
        resolutionDueMinute: 0,
        waitDueColor: "",
        waitDueIsEnable: 0,
        waitDueIsSendMessage: 0,
        waitDueMessage: "",
        waitDueMinute: 0,
        waitNotifyAdmin: 0,
        resolutionNotifyAdmin: 0,
        nonBusinessColor: "",
        channelBusinessHourEnable: 0,
        nonBusinessTime: 0,
        nonBusinessIsSendMessage: 0,
        nonBusinessMessage: "",
        platformConfigId: 99,
      },
      platformIdList: [],
      useSlaFromChannelSetting:
        this.$store.getters.getBrandList()[0]?.useSlaFromChannelSetting,
    };
  },
  watch: {
    isLoading(val) {
      this.$store.commit("UPDATE_MAIN_LOADING", val);
    },
  },
  mounted: async function () {
    if (this.useSlaFromChannelSetting) {
      await this.getList(this.id ? true : false);
      if (this.id) await this.fetchForm();
    } else {
      await this.fetchForm();
    }
  },
  methods: {
    async fetchForm() {
      this.isLoading = true;
      const response = await this.axios.get(
        this.$baseUrl +
          `${
            this.useSlaFromChannelSetting
              ? `/setting/channel-setting/sla/${this.id}`
              : `/Setting/chat-setting/sla/get`
          }`
      );
      if (response && response.result === 1) {
        const { detail } = response;
        this.form = detail;
      }
      this.isLoading = false;
    },
    async onClickSave() {
      this.$v.form.$touch();

      if (this.$v.form.$error) return;
      this.isLoading = true;
      const response = await this.handleSave();
      this.isLoading = false;
      if (response && response.result === 1) {
        this.$store.commit("UPDATE_GLOBAL_ALERT", {
          isShow: true,
          msg: response.message,
        });
      } else {
        this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
          isShow: true,
          msg: response.message || "Something went wrong",
        });
      }

      if (!this.useSlaFromChannelSetting) {
        this.fetchForm();
      }
    },
    async handleSave() {
      try {
        const response = await this.axios.post(
          this.$baseUrl +
            `${
              this.useSlaFromChannelSetting
                ? `/setting/channel-setting/sla`
                : `/Setting/chat-setting/sla`
            }`,
          this.form
        );

        if (response.result == 1) {
          setTimeout(() => {
            this.$router.push({ path: `/setting-sla-policy` }).catch(() => {});
          }, 2000);
        }
        return response;
      } catch (err) {
        return err.response;
      }
    },
    getList: async function (isDetail) {
      this.platformIdList = [];
      await this.axios
        .get(
          `${this.$baseUrl}/system/platformlist?isHasChannelSetting=${isDetail}`
        )
        .then((data) => {
          if (data.result == 1) {
            let list = [{ id: 99, name: "Select Brand" }];
            this.platformIdList = list.concat(
              data.detail
                .filter((ele) => ele.isActive)
                .map((item) => ({
                  id: item.platformConfigId,
                  name: item.pageName,
                  imageUrl: item.imageUrl,
                }))
            );
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
